import { TextAreaFieldInput, Flex } from '@sequencehq/core-components'
import { FieldValidationError } from '../layout'

type Props = {
  description: string
  setDescription: (next: string) => void
  validationErrors?: string[]
  'data-testid'?: string
}

export const DescriptionField = ({
  description,
  setDescription,
  validationErrors,
  'data-testid': dataTestId
}: Props) => (
  <Flex flexDir="column" gap="8px" width="66.6%">
    <TextAreaFieldInput
      data-testid={dataTestId}
      placeholder="Description"
      value={description}
      onChange={e => setDescription(e.target.value)}
      isInvalid={Boolean(validationErrors?.length)}
      autoFocus
    />
    <FieldValidationError errors={validationErrors} />
  </Flex>
)
